import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "sys-help";
const pathData = "M256 410q15 0 26.5-11.5T294 371q0-15-11.5-26.5T256 333q-16 0-27.5 11.5T217 371q0 16 11.5 27.5T256 410zm83-166q9-11 14-23t5-29q0-20-9-36.5t-23-28-32.5-18T256 103t-37.5 6.5-33 18-23.5 28-9 36.5q0 12 8.5 19t20.5 7q25 0 25-26 0-14 13-26t38-12q26 0 39 12t13 26q0 15-8 23-3 3-9 7t-13 8-14 7.5-10 5.5q-6 5-19 14.5T224 282q0 11 10.5 20.5T259 308q10-2 14.5-6.5t7-9l5-9 7.5-7.5q11-5 24-14t22-18zM256 0q53 0 99.5 20T437 75t55 81.5 20 99.5-20 99.5-55 81.5-81.5 55-99.5 20-99.5-20T75 437t-55-81.5T0 256t20-99.5T75 75t81.5-55T256 0zm0 461q42 0 79.5-16t65-44 44-65.5T461 256t-16.5-79.5-44-65-65-44T256 51t-79.5 16.5-65.5 44-44 65T51 256t16 79.5 44 65.5 65.5 44 79.5 16z";
const ltr = true;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/sys-help";
export { pathData, ltr, accData };